import { BlueButton, TextButton } from '../../Buttons/styled';
import { StyledFooterWrapper } from '../styled';

export type Props = {
  disabled?: boolean;
  onCancel?: () => void;
  name?: string;
  onSubmit?: () => void;
};
const SideBarFooter = ({ onCancel, name, onSubmit, disabled = false }: Props): JSX.Element => {
  return (
    <StyledFooterWrapper>
      {onCancel && <TextButton name="Cancel" type="submit" data-testid="formCancelButton" onClick={onCancel} />}
      {name && (
        <BlueButton disabled={disabled} name={name} type="submit" data-testid="formSubmitButton" onClick={onSubmit} />
      )}
    </StyledFooterWrapper>
  );
};

export default SideBarFooter;
